const profile = {
    name: '姓名',
    avatar: '头像',
    givenName: '名',
    familyName: '姓',
    middleName: '中间名',
    fullName: '全名',
    nickname: '昵称',
    preferredUsername: '首选用户名',
    profile: '个人资料',
    website: '网站',
    gender: '性别',
    birthdate: '出生日期',
    zoneinfo: '时区信息',
    locale: '语言环境',
    address: {
        formatted: '地址',
        streetAddress: '街道地址',
        locality: '城市',
        region: '州 / 省份',
        postalCode: '邮政编码',
        country: '国家',
    },
};
export default Object.freeze(profile);
